import { render, staticRenderFns } from "./Fantasyladder.vue?vue&type=template&id=3d4d6daa&scoped=true&"
import script from "./Fantasyladder.vue?vue&type=script&lang=js&"
export * from "./Fantasyladder.vue?vue&type=script&lang=js&"
import style0 from "./Fantasyladder.vue?vue&type=style&index=0&id=3d4d6daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d6daa",
  null
  
)

export default component.exports